<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.promo_campaign" :label="labels.promo_campaign" :error-messages="errors.collect('promo_campaign')" data-vv-name="promo_campaign" :data-vv-as="labels.promo_campaign"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.promo_description" :label="labels.promo_description" :error-messages="errors.collect('promo_description')" data-vv-name="promo_description" :data-vv-as="labels.promo_description"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <cal-picker :label="labels.promo_effDate" v-model="filters.promo_effDate" :error-messages="errors.collect('promo_effDate')" data-vv-name="promo_effDate" :data-vv-as="labels.promo_effDate"></cal-picker>
                      </v-flex>
                      <v-flex md6>
                        <cal-picker :label="labels.promo_expDate" v-model="filters.promo_expDate" :error-messages="errors.collect('promo_expDate')" data-vv-name="promo_expDate" :data-vv-as="labels.promo_expDate"></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew()">
            New Promotion
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.promo_campaign }}</td>
                <td>{{ row.item.promo_description }}</td>
                <td>{{ formatDisplayDate(row.item.promo_effDate) }}</td>
                <td>{{ formatDisplayDate(row.item.promo_expDate) }}</td>
                <td>{{ row.item.promo_stdPromo ? 'YES' : 'NO' }}</td>
                <td>{{ row.item.promo_cardPromo ? 'YES' : 'NO' }}</td>
                <td>{{ row.item.promo_couponPromo ? 'YES' : 'NO' }}</td>
                <td>{{ row.item.promo_usrGrpPromo ? 'YES' : 'NO' }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)" query @query="doQuery(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Promotion?
      </confirm>
    </div>
  </page>
</template>
<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Promotion Factor',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'promotionFactorList' }
        },
        {
          text: 'Promotion Card',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'promotionCardList' }
        },
        {
          text: 'Promotion Coupon',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'promotionCouponList' }
        },
        {
          text: 'Promotion User Group',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'promotionUserGroupList' }
        }
      ],
      toogleArray: [false],
      headers: [
        { text: 'Promotion', value: 'promo_campaign' },
        { text: 'Description', value: 'promo_description' },
        { text: 'Effective Date', value: 'promo_effDate' },
        { text: 'End Date', value: 'promo_expDate' },
        { text: 'Standard Promotion', value: 'promo_stdPromo' },
        { text: 'Card Promotion', value: 'promo_cardPromo' },
        { text: 'Coupon Promotion', value: 'promo_couponPromo' },
        { text: 'User Group Promotion', value: 'promo_usrGrpPromo' },
        TableConst.tableActionHeader
      ],
      labels: {
        promo_campaign: 'Promotion',
        promo_description: 'Description',
        promo_effDate: 'Effective Date',
        promo_expDate: 'End Date '
      },
      filters: {
        promo_campaign: undefined,
        promo_description: undefined,
        promo_effDate: undefined,
        promo_expDate: undefined,
        actionKey: undefined
      },
      totalItems: 0,
      selectedProp: undefined,
      deleteProp: undefined,
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let currFilters = clone(this.filters)
          if (currFilters.promo_effDate) {
            currFilters.promo_effDate = formatDisplayDateTime2(removeTime(currFilters.promo_effDate))
          }
          if (currFilters.promo_expDate) {
            currFilters.promo_expDate = formatDisplayDateTime2(removeTime(currFilters.promo_expDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), currFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  promo_campaign: datamap.promo_campaign,
                  promo_description: datamap.promo_description,
                  promo_effDate: datamap.promo_effDate,
                  promo_expDate: datamap.promo_expDate,
                  promo_stdPromo: datamap.promo_stdPromo,
                  promo_cardPromo: datamap.promo_cardPromo,
                  promo_couponPromo: datamap.promo_couponPromo,
                  promo_usrGrpPromo: datamap.promo_usrGrpPromo,
                  actionKey: datamap.actionKey
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.promo_campaign = undefined
      this.filters.promo_description = undefined
      this.filters.promo_effDate = undefined
      this.filters.promo_expDate = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(obj) {
      this.$router.push({ name: 'promotionReview', params: { paramMode: 'review', paramObjRes: obj } })
    },
    doNew() {
      this.$router.push({ name: 'promotionReview', params: { paramMode: 'create' } })
    },
    doQuery(obj) {
      this.$router.push({ name: 'promotionReview', params: { paramMode: 'query', paramObjRes: obj } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProp = data
      }
    },
    async doRemove() {
      const apiURI = this.menu.doDelete
      if (apiURI) {
        const expand = this.selectedProp
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.campaignParam.menu
    }
  },
  mounted() {
    this.filters.actionKey = 'PROMOTION'
    this.doInit(true)
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    SideFunctionMenu
  }
}
</script>
